angular.module("ainapp")
    .controller("VoucherDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Voucher Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            MainService.GetCompanyProfile().then(function (response) {
                $scope.CompanyProfile = response.data;
            })

            $scope.Users = [];
            MainService.EmployeeUsersInDropDown().then(function (response) {
                $scope.Users = response.data;
            });

            $scope.UserRoles = [];
            MainService.UserRolesInDropdown().then(function (response) {
                $scope.UserRoles = response.data;
            });

            $scope.Init = function () {

                $scope.load = false;


                $scope.LoadFilter = {
                    UserId: "",
                    UserRoleId: "",
                    DesignLoadType: "",
                }
                $scope.ViewVal = 1;
                $scope.ViewVal2 = 0;
                $scope.ViewValType = 'Material Request';
                $scope.selectedVoucher = 'Material Request';

                $scope.CostSetting = {
                    VoucherName: "Material Request",
                }

                $scope.Vdesign = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherDesignsbyType("Material Request").then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.Vdesign = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();

            $scope.loadUserData = function () {

                $scope.LoadFilter.DesignLoadType = "USER";
                $scope.LoadFilter.UserRoleId = "";
                MainService.VoucherDesignsByUserId($scope.ViewValType, $scope.LoadFilter.UserId).then(function (response) {
                   if (response.data != null && response.data != "") {
                        $scope.Vdesign = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.loadRoleData = function () {

                $scope.LoadFilter.DesignLoadType = "ROLE";
                $scope.LoadFilter.UserId = "";
                MainService.VoucherDesignsByRoleId($scope.ViewValType, $scope.LoadFilter.UserRoleId).then(function (response) {
                        if (response.data != null && response.data != "") {
                        $scope.Vdesign = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.loadFromDefault = function () {


                MainService.VoucherDesignsbyType($scope.ViewValType).then(function (response) {
                       if (response.data != null && response.data != "") {
                        $scope.copydata = angular.copy($scope.Vdesign);
                        $scope.Vdesign = response.data;
                        $scope.Vdesign.Id = $scope.copydata.Id;
                        $scope.Vdesign.UserId = $scope.LoadFilter.UserId;
                        $scope.Vdesign.UserRoleId = $scope.LoadFilter.UserRoleId;
                        $scope.Vdesign.DesignLoadType = $scope.LoadFilter.DesignLoadType;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }


            $scope.switchTab = function (tab, type, voucher) {
                $scope.selectedVoucher = voucher;
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.Vdesign = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherDesignsbyType(type).then(function (response) {
                   if (response.data != null && response.data != "") {
                        $scope.Vdesign = response.data;
                    } else {
                        $scope.Vdesign = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



            $scope.saveCostSettings = function () {

                $scope.Vdesign.VoucherName = $scope.ViewValType;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddVoucherDesign($scope.Vdesign).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        if ($scope.LoadFilter.DesignLoadType == "USER") {
                            $scope.loadUserData();
                        } else if ($scope.LoadFilter.DesignLoadType == "ROLE") {
                            $scope.loadRoleData();
                        } else {
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType, $scope.selectedVoucher);
                        }

                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



      }]);
